import React from 'react';
import { ChevronDown, Building2, Clock, FileText } from 'lucide-react';
import { heroData, footerData } from '../../data/mock';

const HeroSection = () => {
  const iconMap = {
    0: Building2,
    1: Clock,
    2: FileText
  };

  return (
    <section className="relative min-h-screen flex items-center pt-24 sm:pt-28 md:pt-32 pb-16 overflow-hidden bg-gradient-to-b from-stone-50 to-white">
      {/* Background Pattern */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-amber-100/30 rounded-full blur-3xl" />
        <div className="absolute top-1/2 -left-40 w-80 h-80 bg-stone-100/50 rounded-full blur-3xl" />
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(0,0,0,0.02) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }} />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo Badge */}
          <div className="flex justify-center mb-10">
            <img 
              src={footerData.logo} 
              alt="Mascarenhas e Lemos Construções" 
              className="h-36 sm:h-44 md:h-52 lg:h-64 w-auto object-contain drop-shadow-lg"
            />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-50 border border-amber-200 rounded-full mb-8">
            <span className="flex h-2 w-2">
              <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
            </span>
            <span className="text-sm font-medium text-amber-800">{heroData.badge}</span>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800 leading-tight mb-6">
            {heroData.title}
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-slate-600 leading-relaxed mb-10 max-w-2xl mx-auto">
            {heroData.subtitle}
          </p>

          {/* Single CTA - Goes to plans */}
          <div className="mb-16">
            <a 
              href="#planos"
              className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-lg text-lg font-semibold shadow-lg shadow-amber-600/25 hover:shadow-amber-600/40 transition-all hover:-translate-y-0.5"
            >
              Conhecer os Planos
              <ChevronDown className="w-5 h-5" />
            </a>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 sm:gap-8 max-w-2xl mx-auto">
            {heroData.stats.map((stat, index) => {
              const Icon = iconMap[index];
              return (
                <div
                  key={index}
                  className="relative group"
                >
                  <div className="bg-white rounded-2xl p-4 sm:p-6 shadow-lg shadow-stone-200/50 border border-stone-100 hover:shadow-xl hover:border-amber-100 transition-all duration-300">
                    <div className="flex justify-center mb-2">
                      <Icon className="w-5 h-5 text-amber-600" />
                    </div>
                    <div className="text-2xl sm:text-3xl font-bold text-slate-800">
                      {stat.value}<span className="text-amber-600">{stat.suffix}</span>
                    </div>
                    <div className="text-xs sm:text-sm text-slate-500 mt-1">{stat.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
          <a href="#personas" className="text-slate-400 hover:text-amber-600 transition-colors">
            <ChevronDown className="w-8 h-8" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
